import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const CompanyList = ({
  optionList,
  onChangeHandle,
  value,
  hasError = false,
  errorMessage = "",
  isRquired = true,
  customTitle = <></>,
  titleview = true,
  selectClass = "slds-select",
  searchable = false,
  customSelectStyles,
}) => {
  useEffect(() => {}, [optionList]);
  const { t } = useTranslation(["workpermit", "util"]);

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "38px",
      borderColor: hasError ? "#ea001e" : base.borderColor,
    }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const filteredOptionList = (optionList || []).filter(
    (item) => item?.softDelete === undefined || item?.softDelete === 0 || item?.softDelete === false || item?.softDelete === "0"
  );

  return (
    <div
      className={`slds-form-element ${hasError ? "slds-has-error" : ""} select-remove-icon mb-2`}
    >
      {titleview && (
        <label className="slds-form-element__label ">
          Company
          {isRquired ? (
            <abbr className="slds-required" title="required">
              *{" "}
            </abbr>
          ) : null}
        </label>
      )}
      {customTitle}
      <div className="slds-form-element__control">
        <div className="slds-select_container">
          {searchable ? (
            <Select
              classNamePrefix="clide-searchable-select"
              options={filteredOptionList.map((item) => ({
                value: item.companyId,
                label: item.companyName,
              }))}
              value={
                value == null || value === ""
                  ? null
                  : (() => {
                      const found = filteredOptionList.find(
                        (item) => String(item.companyId) === String(value),
                      );
                      return found
                        ? { value: found.companyId, label: found.companyName }
                        : null;
                    })()
              }
              onChange={(selectedOption) =>
                onChangeHandle(selectedOption ? selectedOption.value : "")
              }
              placeholder={`${t("select")} ${t("Company")}`}
              //noOptionsMessage={"No Company Available"}
              isClearable
              menuPlacement="auto"
              menuPosition="absolute"
              //menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              styles={customSelectStyles}
            />
          ) : (
            <select
              className={selectClass}
              onChange={(event) => onChangeHandle(event.target.value)}
              value={value}
              styles={customSelectStyles}
            >
              {filteredOptionList.length ? (
                <>
                  <option value="">{t("select")} Company</option>
                  {filteredOptionList.map((item, index) => (
                    <option
                      key={`service-option-${index}`}
                      value={item.companyId}
                    >
                      {item.companyName}
                    </option>
                  ))}
                </>
              ) : (
                <option>{t("noServiceAvailable")}</option>
              )}
            </select>
          )}
        </div>
        {hasError ? (
          <div class="slds-form-element__help" id="error-01">
            {errorMessage !== "" ? errorMessage : t("mandatory")}
          </div>
        ) : null}
      </div>
      <style>{`
        .slds-select_container::before,
        .slds-select_container::after {
          border: none !important;
        }
      `}</style>
    </div>
  );
};

CompanyList.defaultProps = {
  optionList: [],
  value: "",
  searchable: false,
};

export default CompanyList;
